import { Axios } from "@/services/_axios.js";
import store from "@/store/store";
import init from "@/config/init.js";
import { inflate } from "pako";
import { getSystemFoldersBookById } from "../loadBooksDataFromServer";
//  @todo for opening mef on onlybook
//import { fetchBookByID } from "@/services/loadBooksDataFromServer.js";

//@todo for opening mef on onlybook
//const mefoBooksDetails = new Map();

export function getPageRects(book) {
  let url = `${init.getServer()}${init.MefoDB.shas}/${book}`;
  return Axios.get(url)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch(function (error) {
      return Promise.reject(error);
    });
}
export async function getMefoFavs(mas) {
  try {
    let url = `${init.getServer()}api/mefo/favs/${mas}`;
    const response = await Axios.get(url);
    if (response.data.length > 0) {
      response.data.forEach((a) => {
        _store.dispatch("mefo/setUserFavBook", {
          mas: a.masId,
          book: a.bookId,
          subbook: a.subbook,
        });
      });
    }
  } catch (error) {
    console.log(error);
  }
}
export async function setMefoFavs(mas, book, sub) {
  const data = { masId: mas, bookId: book, subbook: sub };
  let url = `${init.getServer()}api/mefo/favs`;
  try {
    const response = await Axios.post(url, data);
    _store.dispatch(`mefo/setUserFavBook`, { mas, book, subbook: sub });
  } catch (error) {
    console.log(error);
  }
}

export async function deleteMefoFavs(mas, book, sub) {
  const bookToDel = { mas, book, subbook: sub };
  let url = `${init.getServer()}api/mefo/favs/${mas}/${book}/${sub}`;
  try {
    const response = await Axios.delete(url);
    _store.dispatch(`mefo/deleteUserFavBook`, bookToDel);
  } catch (error) {
    console.log(error);
  }
}

export function getMefoSectionsByShasId(secShasId) {
  let url = `${init.getServer()}${init.MefoDB.mefarshim}/get`;

  return Axios.post(url, secShasId, { responseType: "arraybuffer" })
    .then(async (response) => {
      let res = response.data;
      if (response.headers["data-type"] == "raw") {
        const decoder = new TextDecoder("utf-8");
        try {
          res = decoder.decode(res);
        } catch {}
      } else res = inflate(response.data, { to: "string" });
      try {
        res = JSON.parse(res);
      } catch (ex) {
        console.log(ex);
        //try remove new lines (bad data)
        res = JSON.parse(res.replaceAll("\n", ""));
      }

      /* if one day we want to get categorybooks on live, here is the place
      let catBooks = await getSystemFoldersBookById(44345); // await getSystemFoldersBookById(secShasId[0]); //44345
      catBooks = [];
      catBooks.forEach((cb) => {
        cb.book = cb.bookId;
        cb.fakeId = 1;
        cb.fav = 0;
        cb.id = cb.bookId + cb.pageId;
        cb.level = 3;
        cb.nextPagesCount = 0;
        cb.pageSectionId = 1;
        cb.priority = 0;
        cb.rects = [
          {
            angle: 0,
            book: cb.bookId,
            h: 1,
            id: 1,
            order: 200,
            page: cb.pageName,
            pageNum: cb.pageNum,
            rectMefoId: 1732685,
            subbook: 0,
            w: 1,
            x: 0,
            y: 0,
          },
        ];
        cb.type = "p";
        cb.yesod = "cat";
      });
      res = res.concat(catBooks); */

      res = res.map((s) => ({
        ...s,
        otzarBook: store.getters["books/getBookbyId"](s.book),
      }));

      /*
     @todo for opening mef on onlybook
     for (let s of res) {
        if (store.state.bookOnlyMode) {
          if (mefoBooksDetails.has(s.book))
            s.otzarBook = mefoBooksDetails.get(s.book);
          else {
            s.otzarBook = await fetchBookByID(s.book);

            s.otzarBook.permissions = s.otzarBook.permissions.reduce(
              (val, obj) => val | (1 << obj.id),
              0
            );

            if (s.otzarBook.permissions == 0)
              s.otzarBook.permissions = undefined;
            if (s.otzarBook.subbooks) {
              let subBooksObj = {};
              s.otzarBook.subbooks.forEach((sb) => (subBooksObj[sb.id] = sb));
              s.otzarBook.subBooks = subBooksObj;
            }

            s.otzarBook.authors_0_name = s.otzarBook.authors[0]?.name;
            s.otzarBook.dor = s.otzarBook.sederdorot?.id || 7;
            mefoBooksDetails.set(s.book, s.otzarBook);
          }
        } else {
          s.otzarBook = store.getters["books/getBookbyId"](s.book);
        }
      } */

      //remove mefs of books that dont exist anymore
      res = res.filter((r) => r.otzarBook);
      return Promise.resolve(res);
    })
    .catch(function (error) {
      return Promise.reject(error);
    });
}

export async function getMefoSectionTitle(secId) {
  let url = `${init.getServer()}${init.MefoDB.catSecTitle}/${secId}`;
  try {
    let response = await Axios.get(url);
    let res = response.data;
    return res;
  } catch (ex) {
    console.log(ex);
    return "";
  }
}
